import {filter} from './lang.js';

export const stats = () => {
    let mem = {};
    let trackMem = {};
    let _stepNumber = undefined;
    let maxLength = 0;
    let maxTriggers = undefined;
    return (... args)  => {
        let [stepData, stepNumber, time, effect] = args;

        stepNumber = effect.track.sequencerEngine.trackStep;
        if (stepData && stepData.track.length > maxLength) {
            maxLength = stepData.track.length;
        }
        stepNumber = stepNumber % maxLength;
        if (stepData && !trackMem[stepData.track.id]) {
            trackMem[stepData.track.id] = {};
            trackMem[stepData.track.id][stepNumber] = 0;
        }
        if (_stepNumber !== stepNumber) {
            if (stepData) {
                trackMem[stepData.track.id][stepNumber] = 0;
            }
            mem[stepNumber] = 0;
        }

        if (stepData) {
            mem[stepNumber]++;
            trackMem[stepData.track.id][stepNumber]++;
            if (isNaN(trackMem[stepData.track.id][stepNumber])) {
                trackMem[stepData.track.id][stepNumber] = 0;
            }
            if (mem[stepNumber] > maxTriggers) {
                maxTriggers = mem[stepNumber];
            }
        }
        _stepNumber = stepNumber;
        effect.mem = {... mem};
        effect.trackMem = {... trackMem};
        effect.maxTriggers = maxTriggers;
        effect.maxLength = maxLength;
        return filter(true);
    };
};
